import styled from 'styled-components';
import { Card, Select, Space, DatePicker } from 'antd';
import { IToken } from 'store/ducks/globalTypes';

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

export const ContentWrapper = styled.div<IToken>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 1200px;
  height: 80vh;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: ${(props) => props.token.boxShadowSecondary};
  border: 1px solid ${(props) => props.token.colorBorder};
  padding: ${(props) => `${props.token.paddingLG}px`};
  z-index: 1000;
  overflow: auto;
`;

export const HeaderSection = styled.div<IToken & { scheme?: string }>`
  margin-bottom: 8px;
  text-align: left;
  padding: ${(props) => `${props.token.paddingSM}px 0`};
  border-bottom: 1px solid ${(props) => props.token.colorBorder};
`;

export const SubTitle = styled.p<IToken>`
  font-size: 14px;
  color: ${(props) => props.token.colorTextSecondary};
  margin: 4px 0 0 0;
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionCard = styled(Card)<IToken & { scheme?: string }>`
  border-radius: 8px;
  box-shadow: ${(props) => props.token.boxShadowTertiary};

  .ant-card-body {
    padding: 24px;
  }

  h4 {
    color: ${(props) => props.token.colorPrimary};
    margin-bottom: 16px;
  }
`;

export const MetricsList = styled.ul`
  margin: 0;
  padding-left: 20px;

  li {
    margin-bottom: 8px;
    line-height: 1.6;
  }
`;

export const VerticalSpace = styled(Space)`
  width: 100%;
`;

export const FilterSelect = styled(Select)`
  min-width: 180px;
  width: auto;
`;

export const FilterDatePicker = styled(DatePicker)`
  width: 200px;
`;

export const dropdownStyles = {
  minWidth: 200,
  backgroundColor: '#ffffff'
};

export const popupStyles = {
  backgroundColor: '#ffffff'
};
